'use client';
import { objectEntries } from '@s7/utils';
import { clonePalette } from '../clonePalette/clonePalette.js';

const reducePaletteWithModes = (palette, mode)=>{
    const result = clonePalette(palette);
    for (const [key, shades] of objectEntries(result)){
        for (const [shadeKey, raw] of objectEntries(shades)){
            if (typeof raw !== 'string') {
                if (raw[mode]) {
                    result[key][shadeKey] = raw[mode];
                } else {
                    delete result[key][shadeKey];
                }
            }
        }
    }
    return result;
};

export { reducePaletteWithModes };
//# sourceMappingURL=reducePaletteWithModes.js.map
